import {
  EMyHomeTypes,
  fetchPublicMyHomeV1GetRealtyList,
  IPublicMyHomeV1GetRealtyListResponse200 as IRes200,
  IPublicMyHomeV1GetRealtyListResponse400 as IRes400,
} from '../../repositories/price-estimator/my-home/v1/get-realty-list';
import type { IMyHomeV2Schema } from '../../repositories/price-estimator/entities/card/MyHomeV2Schema';
import { BadRequestError } from '@cian/valuation-utils-component';
import { IApplicationContext } from '../../types/applicationContext';

export const getMyHomesList = async (context: IApplicationContext): Promise<IMyHomeV2Schema[]> => {
  const { httpApi, logger } = context;

  try {
    const res = await fetchPublicMyHomeV1GetRealtyList<IRes200, IRes400>({
      httpApi,
      parameters: {
        myHomeTypes: [EMyHomeTypes.Secondary], // Запрашиваем всегда вторичку
      },
    });

    if (res.statusCode !== 200) {
      throw new BadRequestError({
        message: res.response.message as string,
        domain: 'getMyHomesList.ts',
        details: {
          errors: JSON.stringify(res.response.errors),
        },
      });
    }

    return res.response.homes;
  } catch (e) {
    if (!(e instanceof BadRequestError)) {
      logger.error('Ошибка загрузки листинга моего дома ', {
        message: e.message,
        domain: 'getMyHomesList.ts',
        details: e,
      });
    } else {
      logger.debug('Ошибка загрузки листинга моего дома ', {
        message: e.message,
        domain: e.domain,
        details: e,
      });
    }

    throw e;
  }
};
